export const API_URL = process.env.API_URL
export const IS_RTM_ENABLED = process.env.IS_RTM_ENABLED === 'true'
export const IS_TETRIS_ENABLED = process.env.IS_TETRIS_ENABLED === 'true'
export const IS_CFR_ENABLED = process.env.IS_CFR_ENABLED === 'true'
export const IS_DANONE_ENV = process.env.APP_NAME === 'Danone'
export const IS_JUME_ENV = process.env.APP_NAME === 'JumeForecast'
export const IS_PRGM_ENV = process.env.APP_NAME === 'Prgm'
export const IS_DEV = process.env.MODE === 'dev'
